export const LabelsModule = {
    namespaced: true,
    state: {
        loadLabelsData: 1,
        LabelsList: [],
        LabelsFilterList: []
    }
}